import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { SharedServiceService } from "../shared/shared-service.service";
import { Router, NavigationStart } from '@angular/router';
import { RestApiServices } from '../providers/rest.service';
import { relative } from 'path';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { CustomStorage } from '../providers/Custom-storage.service';
import { LoaderComponent } from '../loader/loader.component';
import { Constant } from '../Constant';
import { LanguageService } from '../providers/lang.service';
import { CartitemsService } from '../providers/cartitems.service';

@Component({
  selector: 'invoice',
  templateUrl: './invoicelist.component.html',
  styleUrls: ['./invoicelist.component.css'],
})

export class InvoicelistComponent implements OnInit {
  errorData: any
  pay = []
  showDialog: boolean = false;
  invoiceSelected: boolean;
  invoicenotSelected: boolean;
  searchitem = false;
  // invoice_data: Object;
  // statuses = ["All Status", "Paid", "Overdue", "Pending Payment", "Partial"];
  statuses = [];
  selectedStatus = this.statuses[0];
  term: string;
  // tooltipstring:string="THERE ARE NO INVOICES TO PAY"
  // invoice_data = ['0'];
  invoice_data = [];
  isInvoiceDataInit = false
  // invoice_data : Array<any>;
  showloading: boolean = true;
  openSessionDialog: boolean;
  errorMsg: string; getttalvalue: number = 0;
  itemnotfound: string; result_notfound: string = ""; tooltipstring: string = ""; lbl_total: string = "";
  status: string = ""; invoice_search: string = ""; collect_payment: string = ""; due_on: string = "";
  total: string = ""; collected: string = ""; status_result: string = ""; order_no: string = ""; invoice_no: string = "";
  outstanding: string = ""; paid_txt: string = ""; ovedue_txt: string = ""; pending_txt: string = ""; partial_txt: string = "";
  all_status: string = ""; ok_txt: string = ""; no_invoice: string = ""; select_payment: string = "";
  datetext: string = "";
  duedate: string = ""; datemessage: string = "";
  currentDate: Date = new Date()
  emptycartdialog: boolean = false;
  amountOnline: number = 0;
  unchekedvalue: number = 0;
  today: number = Date.now();
  constructor(private sharedService: SharedServiceService, private cartitems: CartitemsService, private langService: LanguageService, private localStorage: CustomStorage, public router: Router, private restApi: RestApiServices) { }

  ngOnInit() {
    var months = []

    this.langService.getSelectedLanguage().subscribe(lang => {
      if (lang[0].languageId === '0') {
        months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      }
      else
        months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']

      //  this.datetext =  months[this.currentDate.getMonth()] + " " + this.currentDate.getDate() + ", " + + this.currentDate.getFullYear()

    })
    this.sharedService.changeFooterSelected('invoice');
    this.sharedService.changeBackbuttonStatus(false);
    this.langService.getJson().subscribe(data => {
      this.setLabels();
      LoaderComponent.loadingV.next(true);
      this.localStorage.getItem(Constant.KEY_INVOICEDATA).subscribe(data => {
        if (data != null && data != undefined) {
          this.invoice_data = data.response.invoices;
          this.isInvoiceDataInit = true
          this.showloading = false;
          LoaderComponent.loadingV.next(false);
        }
        // else{
        //  // this.invoice_data = [];
        //   this.showloading = false;
        //   LoaderComponent.loadingV.next(false);
        // }

        //LoaderComponent.loadingV.next(true);
        this.restApi.getinvoicehistory().subscribe(items => {
          if (items.response.status_code === 200 && items.response.error_message === '') {
            if (items.response.invoices != "") {
              this.invoice_data = items.response.invoices;
              // console.log("invoice"+JSON.stringify(this.invoice_data))
              this.isInvoiceDataInit = true
              this.showloading = false;
              LoaderComponent.loadingV.next(false);
            }
            else {
              this.invoice_data = []
              this.isInvoiceDataInit = true
              this.showloading = false;
              LoaderComponent.loadingV.next(false);
            }
          }

          else {
            this.showloading = false;
            LoaderComponent.loadingV.next(false)
            // this.showloading = false;
            this.openSessionDialog = !this.openSessionDialog;
            this.errorData = items.response
          }
          //}),
          //  error => {
          //   this.showloading = false;
          //     LoaderComponent.loadingV.next(false)
          //     this.errorMsg = error.json().response
          //     this.openSessionDialog = !this.openSessionDialog;
          //   } 

          // this.localStorage.getItem(Constant.KEY_INVOICEDATA).subscribe(data => {
          //   if (data != null && data != undefined) {
          //     this.invoice_data = data.response.invoices;
          //    this.showloading = false;
          //     LoaderComponent.loadingV.next(false)
          //   }
          //  });
        });
      }, error => {
        this.showloading = false;
        LoaderComponent.loadingV.next(false)
        this.errorMsg = error.json().response
        this.openSessionDialog = !this.openSessionDialog;
      });
    });

    // this.date = this.invoice_data.invoices.due_on + " " + months[this.invoice_data.invoices.due_on.getMonth()] + " " + this.invoice_data.invoices.due_on.getFullYear()

  }
  invoicedescription(invoice_data) {
    this.localStorage.setItem('invoiceSelected', invoice_data).subscribe(res => {
      this.router.navigate(['/invoicedescription']);
    });
  }

  getPayment(item, e) {
    this.amountOnline = 0;
    let getttalvalue = 0;
    let index = this.pay.indexOf(item)
    if (e.target.checked) {
      //   console.log(e.target.value);
      // this.invoiceSelected = e.target.checked
      this.pay.push(item)
    }
    else {
      //this.invoiceSelected = false;
      this.pay.splice(index, 1);
    }
    console.log(JSON.stringify(this.pay));
    for (let i = 0; i < this.pay.length; i++) {
      getttalvalue += this.pay[i].total;
      console.log("total value is" + getttalvalue)
      if (i == this.pay.length - 1) {
        this.amountOnline = getttalvalue;
      }
    }
    this.localStorage.setItem('payAmt', this.pay).subscribe(res => {

    })
    // this.sharedService.setInvoiceAmount(this.pay)
  }
  collectpayment() {
    if (this.pay.length != 0) {
      this.router.navigate(['/collect']);
    }
    else {
      this.emptycartdialog = !this.emptycartdialog;
    }

  }
  NotSelected() {
    for (let item of this.invoice_data) {
      // if( item.status != 1  && item.item_fr_invoice_nt_foundmsg == undefined){
      if (item.status != 1) {

        return false;
      }

    }
    return true;
  }

  openSessionCheck() {
    // this.localStorage.emptyStorage();
    this.sharedService.removeAllData();
    this.openSessionDialog = !this.openSessionDialog;
    this.router.navigate(['/login'])
  }
  setLabels() {

    this.langService.getLangLabelValue("LblAllStatuses").then(result => {
      this.status = result;
    });
    this.langService.getLangLabelValue("LblInvoiceOrOrderNumberSearch").then(result => {
      this.invoice_search = result;
    });
    this.langService.getLangLabelValue("LblCollectPayment").then(result => {
      this.collect_payment = result;
    });
    this.langService.getLangLabelValue("LblDueOn").then(result => {
      this.due_on = result;
    });
    this.langService.getLangLabelValue("LblTotal").then(result => {
      this.total = result;
    });
    this.langService.getLangLabelValue("LblCollected").then(result => {
      this.collected = result;
    });
    this.langService.getLangLabelValue("LblStatus").then(result => {
      this.status_result = result;
    });
    this.langService.getLangLabelValue("LblOrder").then(result => {
      this.order_no = result;
    });
    this.langService.getLangLabelValue("LblInvoice").then(result => {
      this.invoice_no = result;
    });
    this.langService.getLangLabelValue("LblNoInvoices").then(result => {
      this.no_invoice = result;
    });
    this.langService.getLangLabelValue("LblTotalOutstanding").then(result => {
      this.outstanding = result;
    });
    this.langService.getLangLabelValue("Lblok").then(result => {
      this.ok_txt = result;
    });
    this.langService.getLangLabelValue("LblTotal").then(res => {
      this.lbl_total = res
    });
    this.langService.getLangLabelValue("LblSelectOnePaymentMethod").then(result => {
      this.select_payment = result;
    });
    this.langService.getLangLabelValue("LblAllStatus").then(result => {
      this.all_status = result;
      this.statuses.push(this.all_status);
      this.cartitems.invoicestatuses[this.all_status] = 0;
    });
    this.langService.getLangLabelValue("LblPaid").then(result => {
      this.paid_txt = result;
      this.statuses.push(this.paid_txt);
      this.cartitems.invoicestatuses[this.paid_txt] = 1;
    });
    this.langService.getLangLabelValue("LblOverdue").then(result => {
      this.ovedue_txt = result;
      this.statuses.push(this.ovedue_txt);
      this.cartitems.invoicestatuses[this.ovedue_txt] = 2;
    });
    this.langService.getLangLabelValue("LblPendingPayment").then(result => {
      this.pending_txt = result;
      this.statuses.push(this.pending_txt);
      this.cartitems.invoicestatuses[this.pending_txt] = 3;
    });
    this.langService.getLangLabelValue("LblPartial").then(result => {
      this.partial_txt = result;
      this.statuses.push(this.partial_txt);
      this.cartitems.invoicestatuses[this.partial_txt] = 4;
    });
    this.langService.getLangLabelValue("200_no_data_found").then(res => {
      this.result_notfound = res
    });
    this.langService.getLangLabelValue("LblNoInvoices").then(res => {
      this.tooltipstring = res
    });

  }
  closeSessionDialog() {
    this.localStorage.emptyStorage();
    this.router.navigate(['/login'])
  }

  convertintodateformat(date2) {
    var date22 = new Date(date2);
    var year22 = date22.getFullYear();
    var month22 = date22.getMonth() + 1;
    var dt22 = date22.getDate();

    if (dt22 < 10) {
      dt22 = 0 + dt22;
    }
    if (month22 < 10) {
      month22 = 0 + month22;
    }
    return year22 + '-' + month22 + '-' + dt22;
  }

  getstatusmsg(statusNo) {

    if (statusNo == "1") {
      return this.paid_txt;
    }
    if (statusNo == "2") {
      return this.ovedue_txt;
    }
    if (statusNo == "3") {
      return this.pending_txt;

    }
    if (statusNo == "4") {
      return this.partial_txt;
    }
    return "";
  }



  calculateDate(item) {
    var date1 = new Date(this.today);
    // console.log('***'+JSON.stringify(item));
    if (JSON.stringify(item) !== undefined) {
      let invdate = JSON.stringify(item.invoice_date);

      var date2 = new Date(invdate);

      var timestamp1 = date1.getTime();
      var timestamp2 = date2.getTime();
      var timeStampDiff = ((timestamp1 - timestamp2) / (1000 * 60 * 60 * 24));
      var diffDays = Math.round(timeStampDiff);
      return diffDays;

    }

  }
}


// WEBPACK FOOTER //
// ./src/app/invoicelist/invoicelist.component.ts